import { FilterType } from "./filter-type.model";

export class FilterTab {
    constructor(
        public id: number,
        public labels: FilterType[],
        public disabled: boolean,
        public selectedCount: number
    ) {}
}
